import { GetOrders } from './getOrders'
import {DEFAULT_PAGE} from "../../contstants";
import getDateRange from "../../utils/getDateRange";

const FilterOrders = async (perPage, filters) => {

    const page = filters.page || DEFAULT_PAGE;
    const name = filters.s || '';
    const company_id = filters.company_id || '';
    const office_id = filters.office_id || '';
    const status = filters.status || '';
    const id = filters.id || '';

    const { dateFrom, dateTo } = getDateRange(filters.date);

    return await GetOrders(
        perPage,
        (page - 1) * perPage,
        name,
        company_id,
        office_id,
        status,
        dateFrom,
        dateTo,
        id);
};

export default FilterOrders;
